module.exports = __webpack_public_path__ + "static/media/humidity.bd03f1b3.png";